import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useDeviceDelete = ({ onFetchDevices }) => {
  const { onSubmit: handleDelete } = useFetch('device-delete', Api.DEVICE);

  const onDeleteDevice = (id, toggle) => () =>
    handleDelete({
      method: 'DELETE',
      pathParams: { id },
      onSuccess: () => {
        onFetchDevices();
        toggle();
      },
    });

  return {
    onDeleteDevice,
  };
};

export default useDeviceDelete;
